import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import { getCurrentInstance, reactive, ref, onMounted } from 'vue'
import { useStore } from '@/store'
import { getBankReceiptListApi, checkPrepayApi } from '@/apis/invoice'
import { joinParams } from '@/utils/index'
import Keys from '@/constant/key'
import SelectChannel from '../../components/SelectChannel.vue'
import Pagination from '@/components/Pagination.vue'
import { PrepayCheckStatus } from '../../enums/invoice'


export default /*@__PURE__*/_defineComponent({
  __name: 'PrepayList',
  setup(__props) {

const store = useStore()
const { proxy } = getCurrentInstance() as any
const userInfo = store.state.user.userInfo

const filters = reactive({
    type:           1,      // 操作类型：1-列表，2-导出
    channel_name:   '',     // 渠道号
    payer_name:     '',     // 付款人户名
    payer_account:  '',     // 付款人账号
    payer_bank:     '',     // 付款人开户银行
    amount:         '',     // 金额
    start_time:     '',     // 提交开始日期
    end_time:       '',     // 提交结束日期
    status:         '',     // 审核状态
    page:           1,
    page_size:      10,
})

// 获取发票列表
const total = ref(0)
const tableData = ref([])
const getTableData = async () => {
    const { code, data, msg } = await getBankReceiptListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    tableData.value = data.data
    total.value = data.total || 0
}

// 审核
const rejectDialog = ref(false) // 驳回弹框
const rowId = ref('') // 当前行ID
const msg = ref('') // 驳回原因
const onCheck = (status) => {
    if (status == 2 && !msg.value.trim()) return proxy.$message({ type: 'error', message: '请填写驳回原因' })
    proxy.$confirm(`确定要${status==1 ? '通过' : '驳回'}当前记录吗？`, '提示', {
        type: 'warning'
    }).then(() => {
        checkPrepayApi({
            id: rowId.value,
            msg: msg.value.trim(),
            status
        }).then((res:any) => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'success', message: '审核成功' })
            rejectDialog.value = false
            getTableData()
        })
    }).catch(() => {
        console.log('取消审核')
    })
}

// 渠道变化监听
const onChannelChange = (val) => {
    filters.channel_name = val ? val.channel_name : ''
}

// 多选监听及导出
const selectedIds = ref([])
const onSelectionChange = (val) => {
    selectedIds.value = val
}

// 批量导出
const onExport = () => {
    let ids:string = '' // 选中的条目
    let idsArr:Array<string> = []
    idsArr = selectedIds.value.map((item:any) => item.id)
    ids = idsArr.join(',')
    let url = `${Keys.baseUrl}/admin/channel/finance_bank_receipt_list?${joinParams({...filters, user_id: userInfo.id, type: 2, ids})}`
    window.open(url)
}

const onSearch = () => {
    filters.page = 1
    getTableData()
}
const onPageChange = (val:number) => {
    filters.page = val
    getTableData()
}
const onSizeChange = (val:number) => {
    filters.page_size = val
    getTableData()
}

onMounted(() => {
    getTableData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectChannel, { onChannelChange: onChannelChange }),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.payer_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.payer_name) = $event)),
        placeholder: "账户名称",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.payer_account,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.payer_account) = $event)),
        placeholder: "账号",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.payer_bank,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.payer_bank) = $event)),
        placeholder: "开户银行",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.amount,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.amount) = $event)),
        placeholder: "金额",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_time,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.start_time) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "提交开始日期",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_time,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.end_time) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "提交结束日期",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        filterable: "",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.status) = $event)),
        placeholder: "审核状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: ""
          }),
          _createVNode(_component_el_option, {
            label: "待审核",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "审核通过",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "驳回",
            value: 2
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        onClick: onSearch
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        onClick: onExport
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createTextVNode("批量导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: "",
      onSelectionChange: onSelectionChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "selection" }),
        _createVNode(_component_el_table_column, {
          prop: "channel_name",
          label: "渠道名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "payer_name",
          label: "账户名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "payer_account",
          label: "账号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "payer_bank",
          label: "开户行"
        }),
        _createVNode(_component_el_table_column, {
          prop: "receipt_number",
          label: "回单编号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "serial_number",
          label: "流水号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "amount",
          label: "金额"
        }),
        _createVNode(_component_el_table_column, { label: "状态" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_unref(PrepayCheckStatus)[scope.row.status]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "msg",
          label: "驳回原因"
        }),
        _createVNode(_component_el_table_column, {
          prop: "transaction_date",
          label: "交易日期"
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "提交日期"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "95"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => {rowId.value=scope.row.id;onCheck(1)},
                disabled: _unref(PrepayCheckStatus)[scope.row.status] !== '待审核'
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode("审核通过")
                ])),
                _: 2
              }, 1032, ["onClick", "disabled"]),
              _createVNode(_component_el_button, {
                type: "danger",
                size: "small",
                onClick: ($event: any) => {rowId.value=scope.row.id;msg.value='';rejectDialog.value=true},
                class: "mt10",
                disabled: _unref(PrepayCheckStatus)[scope.row.status] !== '待审核'
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("驳回")
                ])),
                _: 2
              }, 1032, ["onClick", "disabled"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "驳回原因",
      modelValue: rejectDialog.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((rejectDialog).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "info",
          plain: "",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (rejectDialog.value = false))
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (onCheck(2)))
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [
            _createTextVNode("驳 回")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_input, {
            type: "textarea",
            modelValue: msg.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((msg).value = $event)),
            maxlength: "100",
            rows: 4,
            "show-word-limit": "",
            placeholder: "请填写驳回原因"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})